import { toMinorUnits } from '@features/quote/utils/money';

export interface PricedLine {
    price: number;
    gross_price: number;
}

// A line missing either figure is `unpriced` at the payment step, so it carries
// no money into the summary and shows no currency in the configurator.
// `toMinorUnits(null)` coerces to `0`, so nullish values must be rejected before conversion.
export const isPricedLine = (line: PricedLine): boolean =>
    line.price != null &&
    line.gross_price != null &&
    Number.isFinite(toMinorUnits(line.price)) &&
    Number.isFinite(toMinorUnits(line.gross_price));
